import Vue from 'vue'
import authenticationActionTypes from '@/modules/authentication/store/authentication.actiontype'
// naming convention
// raw name mean set, LOADING => mean set LOADING

// user store
let userActionTypes = {
    TOKEN: 'TOKEN',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    CURRENT_PROJECT_ID: 'CURRENT_PROJECT_ID',
    GET_PROFILE: 'GET_PROFILE',
    GET_PROJECTS: 'GET_PROJECTS',
    RESET_TOKEN: 'RESET_TOKEN',
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT',
    ACTIVE_PROJECT: 'ACTIVE_PROJECT',
    AGENT_LIST: 'AGENT_LIST',
    GET_AGENT_LIST: 'GET_AGENT_LIST'
}
let userActionTypesShortcut = { ...userActionTypes }

Object.keys(userActionTypes).forEach(item => {
    userActionTypesShortcut[item] = 'user/' + userActionTypes[item]
})

// dashboard store
let dashboardActionTypes = {
    TIME_RANGE: 'TIME_RANGE'
}

let dashboardActionTypesShortcut = { ...dashboardActionTypes }

Object.keys(dashboardActionTypes).forEach(item => {
    dashboardActionTypesShortcut[item] = 'dashboard/' + dashboardActionTypes[item]
})

// auth store

let authenticationActionTypesShortcut = { ...authenticationActionTypes }

Object.keys(authenticationActionTypesShortcut).forEach(item => {
    authenticationActionTypesShortcut[item] = 'auth/' + authenticationActionTypesShortcut[item]
})

// main store
const actionTypes = {
    // common for both action and mutation in main store
    LOADING: 'LOADING',
    TOGGLE_NAVIGATION: 'TOGGLE_NAVIGATION',
    NAVIGATION: 'NAVIGATION',
    TOUR_CONSOLE: 'TOUR_CONSOLE',
    TOKEN: 'TOKEN',
    user: { ...userActionTypesShortcut },
    dashboard: { ...dashboardActionTypesShortcut },
    auth: { ...authenticationActionTypesShortcut }
}

Vue.prototype.$actionTypes = actionTypes

export {
    userActionTypes,
    dashboardActionTypes,
    actionTypes
}
